import { SpearIcon } from './SpearIcon';

/**
 * author: Colton Wiscombe
 * id B8B83A21-D267-47BD-868F-BECB081CEC1C
 * name spear
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/spear.svg
 * tags
 * - Gaming / RPG 
 */
export const StaffIcon = SpearIcon;
export default StaffIcon